import useSWR from 'swr';
import { ReportByKind, ReportKind } from '../types';

export type ReportParams = Record<string, string | number | null | undefined>;

/** Drops empty values: the global fetcher would send them as the strings "undefined" and "null". */
export const cleanReportParams = (params: ReportParams) =>
    Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
    ) as Record<string, string | number>;

export const useReport = <K extends ReportKind>(report: K, clubSlug?: string | null, params?: ReportParams | null) =>
    useSWR<{ data: ReportByKind[K] }>(
        clubSlug && params?.mandant_id ? [`invoice/${clubSlug}/reports/${report}`, cleanReportParams(params)] : null,
        { keepPreviousData: true }
    );

export default useReport;
